import { EmptyStateEmail } from 'ui/illustrations';

import {
  containerStyles,
  deviceStylesDesktop,
  deviceStylesCommon,
  deviceStylesUnset,
  messageUnset,
  deviceStylesMobile,
} from './styles';
import { displayContent } from '../../common/content';
import { OSWebPush, PlatformWebPush } from '../../common/types';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { useWebPushPreviewContext } from '../context/WebPushPreviewContext';
import { DesktopPreview } from './DesktopPreview';
import { MobilePreview } from './MobilePreview';

type Props = {
  selectedPlatform: PlatformWebPush;
  selectedOS: OSWebPush;
};

export const Preview = ({ selectedPlatform, selectedOS }: Props) => {
  /* only show the empty state if the message in the template data is not defined, even if the
   * message is a snippet which resolves to an empty string */
  const { hasContent } = useEditableFieldsContext();
  const { previewError: hasPreviewError } = useWebPushPreviewContext();

  const PreviewContent =
    selectedPlatform === PlatformWebPush.Desktop ? DesktopPreview : MobilePreview;

  return (
    <div data-test="web-push-preview" style={containerStyles}>
      <div
        data-test="template-editor-web-push-preview"
        style={{
          ...deviceStylesCommon,
          ...(hasContent &&
            (selectedPlatform === PlatformWebPush.Desktop
              ? deviceStylesDesktop
              : deviceStylesMobile)),
          ...(!hasContent && deviceStylesUnset),
        }}
      >
        {hasContent && !hasPreviewError ? (
          <PreviewContent selectedOS={selectedOS} />
        ) : (
          <>
            <EmptyStateEmail height={100} width={100} />
            {!hasPreviewError && (
              <div data-test="web-push-empty-state" style={messageUnset}>
                {displayContent.strEmptyContentWebPush}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Preview;
